module.exports = __webpack_public_path__ + "static/media/n01.da36c68e.jpg";